// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

const BaseCampaignBuilderAreaRoutes = {
  route: '/campaign-builder',
  CampaignManagement: {
    route: 'campaign-management',
  },
  NewCampaign: {
    route: 'new-campaign',
  },
  InspectCampaign: {
    route: 'inspect-campaign',
  },
}

export const CampaignBuilderAreaRoutes = transformRoutes(
  BaseCampaignBuilderAreaRoutes,
)
